<template>
  <v-row dense>
    <v-col cols="12">
      <textarea-field
        v-model="description"
        data-testid="input-description"
        :prepend-inner-icon="mdiText"
        label="Description"
        placeholder="Consider including height, weight, medical concerns, medications, specific products and/or the overall goal of insurance (i.e. permanent insurance with LTC rider)."
        :success="descriptionValidation.success"
        :error-messages="descriptionValidation.errorMessages"
      />
    </v-col>
    <v-col cols="12">
      <file-drag-and-drop
        v-model="files"
        data-testid="input-files"
        :prepend-inner-icon="mdiFileDocument"
        :label="isGroup ? 'Census File' : 'Upload Document (optional)'"
        accept="all"
        multiple
        hide-details="auto"
        v-bind="filesValidation"
      />
      <div v-if="isGroup" class="w-100 d-flex">
        <v-spacer />
        Don't have a census?
        <div class="ml-1 d-inline">
          <a
            href="https://cdn.back9ins.com/help-desk/uploads/Census.Worksheet.xlsx"
          >
            Here's an example
          </a>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script setup>
import FileDragAndDrop from "@/components/shared/FileDragAndDrop.vue";
import { computedValidation } from "@/util/helpers";
import { useQuoteRequestStore } from "@/stores/quote-request";
import useVuelidate from "@vuelidate/core";
import { storeToRefs } from "pinia";
import { mdiText } from "@mdi/js";
import { computed } from "vue";
import { QUOTE_REQUEST_LINE } from "@/models/Quote";
import { mdiFileDocument } from "@mdi/js";

const quoteRequest = useQuoteRequestStore();

const { files, description, line } = storeToRefs(quoteRequest);

const isGroup = computed(() => line.value === QUOTE_REQUEST_LINE.GROUP);

const v$ = useVuelidate(
  {
    files: {
      required: v => {
        if (isGroup.value) return Boolean(v?.length);
        return true;
      },
      allSized: v => v.every(file => file.size > 0)
    },
    description: {
      required: v => !!v
    }
  },
  { files, description },
  { $autoDirty: true, $scope: "quote-request" }
);

const filesValidation = computedValidation(v$.value.files, {
  required: "Required",
  allSized: "Please confirm these files have data or try re-uploading all files"
});

const descriptionValidation = computedValidation(v$.value.description, {
  required: "Required"
});
</script>
